import React, { useState } from "react";
import "../../pages/NewMember/style/style.scss";
import { useLocation, useNavigate } from "react-router-dom";
import "./style.scss";
import { isEmpty } from "../../utils/common";
import { assignDevice, searchUser } from "../../utils/api";
import { AlertWrapper } from "../../Components/Modal/style";
import LocalLoader from "../../Components/Loader/LocalLoader";

const DeviceMapping = () => {
  const [userId, setUserId] = useState("");
  const [userUuid, setUserUuid] = useState("");
  const [assigneeName, setAssigneeName] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({});
  const [disableBtn, setDisableBtn] = useState(false);
  const [errors, setErrors] = useState("");
  const [userData, setUserData] = useState("");
  const navigate = useNavigate();

  const [userDetail,setUserDetail] =useState(false);

  const location = useLocation();
  let deviceDataList = {};
  let key = "";
  if (!isEmpty(location.state)) {
    deviceDataList = location.state.assigneeDevice;
    key = location.state.key;
  }

  const handleDeviceMap = () => {
    let error = {};
    if (isEmpty(userId)) {
      error.userId = "please enter username";
    }else if (userData !== "ROLE_RETAILER") {
      error.userId = "Cannot assign device to this user";
    }
    setErrors(error);

    let inventoryId = deviceDataList?.uuid;

  

    if (isEmpty(error)) {
      setDisableBtn(true);
      setLoading(true);
      assignDevice(inventoryId, userUuid).then((resp) => {
      

        if (resp?.data?.success) {
          setMessage({ msg: "Device assigned successfully.", type: "success" });
          setLoading(true);
          setTimeout(() => {
            navigate("/assign-device");
            setDisableBtn(false);
            setLoading(false);
          }, 2000);
        } else {
            setDisableBtn(false);
        setLoading(false);
          let msg = "";

          if (resp?.data?.errorCodeList.length > 0) {
            msg = resp?.data?.errorCodeList[0];
          } else {
            msg = resp?.data?.msg;
          }
          setMessage({ msg: msg, type: "error" });
        }
      }).catch(()=>{
        setMessage({ msg: "Somthing went wrong", type: "error" });
          setDisableBtn(false);
        setLoading(false);
      })
    }
  };

  const numberReg = /^[0-9]+$/;
  const findUserName = (e) => {
    setAssigneeName("");
    const value = e.target.value;

    if (!numberReg.test(value) && value) {
      return;
    } else {
      setUserId(value);
      if (value.length === 10) {
        setUserDetail(true)
        searchUser(value).then((resp) => {
          setUserDetail(false)
          if (resp?.data?.success) {         
            setUserData(resp?.data?.data?.userType);
            setUserUuid(resp?.data?.data?.uuid);
            setAssigneeName(
              resp?.data?.data?.firstName + " " + resp?.data?.data?.lastName
            )?.toUpperCase();
          
          } else {
            setUserUuid("null");
            setAssigneeName("No user found");
            setUserData("No user found");
          }
        });
      }
    }
  };
 
  return (
    <>
      {loading && <LocalLoader className="tableLoader" />}
      {!isEmpty(message) && (
        <AlertWrapper className={`${message.type} globle`}>
          <span className="close" onClick={() => setMessage({})}>
            ×
          </span>
          {message.msg}
        </AlertWrapper>
      )}
      <div className="device_main_container">
        <div className="subadmin_head flex mt-20">
          <strong>Device Map</strong>
        </div>

        <div className="device_map_container">
            <div className="pd-30 flex column align-items ">
              <div >
                <lable className="filter_text fs">UserName</lable>
                    <div className="mg-top3">
                      <input
                        type="text"
                        name="userId"
                        className="filter_select  fs"
                        placeholder="Enter Mobile Number"
                        value={userId}
                        onChange={findUserName}
                        maxLength={10}
                      ></input>
                    
                    {errors.userId && (
                      <p className="error fs-12 mt-10">{errors.userId}</p>
                    )}
                  </div>
                  </div>
                  <div>
                  {userDetail  && <label>Loading...</label>}
                  {!isEmpty(userId) && userId?.length === 10 && !isEmpty(assigneeName) && (
                    <div className="flex row gap-40 mt-10">
                      
                      <div>
                        <label className=" flex column fs-12 fw-500">
                         {assigneeName!=="No user found" && <label>Name</label>} 
                          <span className="blue_font fw-bold">
                            {assigneeName.toUpperCase()}
                          </span>
                        </label>
                      </div>
                      {(assigneeName!=="No user found") &&
                      <div>
                      <label className=" flex column fs-12 fw-500">
                        Designation
                        <span className="blue_font fw-bold">
                          {userData === "ROLE_ADMIN"
                            ? "ADMIN"
                            : userData === "ROLE_DISTRIBUTOR"
                            ? "DISTRIBUTOR"
                            : userData === "ROLE_RETAILER"
                            ? "RETAILER"
                            : ""}
                        </span>
                      </label>
                    </div>
                      }
                      
                    </div>
                  )}
                  </div>     
              <div>
                <button
                  onClick={() => {
                    handleDeviceMap();
                  }}
                  disabled={disableBtn || userDetail}
                  className={
                    disableBtn
                      ? "ticket_input-field_button_disable map_btn"
                      : "userlist_btn map_btn"
                  }
                >
                  Assign Device
                </button>
              </div>
            </div>
          </div>
        </div>
    </>
  );
};

export default DeviceMapping;
